import {Component, OnInit, ViewContainerRef, Inject, ViewChild, TemplateRef} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {MatIconRegistry, MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {Router, ActivatedRoute} from '@angular/router';
import {Http, Response, Headers} from '@angular/http';
import {CustomHttp} from '../../../common/customHttp.service';
import {ApiUrl} from '../../../common/apiUrls';
import {FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {ValidationService} from '../../../common/validationservice';
import {MainAppComponent} from '../../../layout/layout.component';
import {PagerService} from '../../../common/pagerService';
import 'rxjs/add/operator/map';

@Component({
  selector: 'demo-jazz-dialog',
  providers: [MainAppComponent],
  template: `
    <h4 style="text-align: center">Forgot Password</h4>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
      <mat-form-field style="width: 100%">
        <input matInput formControlName="Email" placeholder="Email" #email >
      </mat-form-field>
      <span style="color: red;font-size: 12px" *ngIf="(forgotPasswordForm['controls'].Email.hasError('pattern'))"><br>Enter valid email id (Eg: abcd@gmail.com)</span>
      <span style="color: red;font-size: 12px" *ngIf="(forgotPasswordForm['controls'].Email.hasError('minlength') && isSubmitted)"><br>Email Length between 1 to 100</span>
      <span style="color: red;font-size: 12px" *ngIf="(forgotPasswordForm['controls'].Email.hasError('maxlength') && isSubmitted)"><br>Email Length between 1 to 100</span>
      <div style="clear: both;float: right;">
        <button type="button" [disabled]="isEmailValid" (click)="dialogRef.close(forgotPasswordForm.value)"
        mat-raised-button
                color="primary">Send
        </button>
        <button mat-raised-button mat-dialog-close>Close</button>
      </div>
    </form>`
})
export class ForgotpasswordComponent implements OnInit {
  private _dimesionToggle = false;
  forgotPasswordForm: FormGroup;
  isSubmitted:false;
  isEmailValid: boolean = false;

  constructor(public dialogRef: MatDialogRef<ForgotpasswordComponent>, private _formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _http: CustomHttp, private _appUrl: ApiUrl,
              private _route: ActivatedRoute,
              private _validationService: ValidationService, private _mApp: MainAppComponent
    , private _toastrService: ToastrService) {

  }

  ngOnInit() {

    this.dialogRef
      .updateSize('400px', '210px')
      .updatePosition({top: '100px', left: '485px'});
    this.forgotPasswordForm = this._formBuilder.group({
      Email: ['', Validators.compose([Validators.required,Validators.pattern(this._validationService.emailPattern)])],
    });
  }


  ngDoCheck() {
    if (this.forgotPasswordForm.valid)
      this.isEmailValid = false;
    else
      this.isEmailValid = true;
  }

  ngOnDestroy() {

  }
  onSubmit(){}

  togglePosition(): void {

    this._dimesionToggle = !this._dimesionToggle;

    if (this._dimesionToggle) {
      this.dialogRef
        .updateSize('500px', '500px')
        .updatePosition({top: '25px', left: '25px'});
    } else {
      this.dialogRef
        .updateSize()
        .updatePosition();
    }
  }
}
